export const palettes = [
    {
        id: 'a',
        label: 'default',
        palette: {
            themePrimary: '#0481e0',
            themeLighterAlt: '#f4f9fe',
            themeLighter: '#d3e9fa',
            themeLight: '#aed7f6',
            themeTertiary: '#61b0ed',
            themeSecondary: '#1f8fe4',
            themeDarkAlt: '#0474ca',
            themeDark: '#0362ab',
            themeDarker: '#03487e'
        }
    },
    {
        id: 'b',
        label: 'blueLight',
        palette: {
            themePrimary: '#2694bf',
            themeLighterAlt: '#f4f9fe',
            themeLighter: '#d3e9fa',
            themeLight: '#aed7f6',
            themeTertiary: '#518ebd',
            themeSecondary: '#2274A5',
            themeDarkAlt: '#007399',
            themeDark: '#006080',
            themeDarker: '#3f7cab'
        }
    },
    {
        id: 'c',
        label: 'sky',
        palette: {
            themePrimary: '#274472',
            themeLighterAlt: '#3064b8',
            themeLighter: '#5885AF',
            themeLight: '#41729F',
            themeTertiary: '#057DCD',
            themeSecondary: '#285499',
            themeDarkAlt: '#003060',
            themeDark: '#055C9D',
            themeDarker: '#0E86D4'
        }
    },
    {
        id: 'd',
        label: 'red',
        palette: {
            themePrimary: '#F55C47',
            themeLighterAlt: '#e0523f',
            themeLighter: '#cc3c29',
            themeLight: '#d17062',
            themeTertiary: '#d64b2f',
            themeSecondary: '#f0554d',
            themeDarkAlt: '#e04343',
            themeDark: '#b82a2a',
            themeDarker: '#cc4a33'
        }
    },
    {
        id: 'e',
        label: 'green',
        palette: {
            themePrimary: '#45a82c',
            themeLighterAlt: '#40b522',
            themeLighter: '#469e2f',
            themeLight: '#4b9e36',
            themeTertiary: '#4fb037',
            themeSecondary: '#2ca83e',
            themeDarkAlt: '#57c23c',
            themeDark: '#2a8c11',
            themeDarker: '#34a617'
        }
    },
    {
        id: 'f',
        label: 'yellow',
        palette: {
            themePrimary: '#deb143',
            themeLighterAlt: '#FADF63',
            themeLighter: '#EEB76B',
            themeLight: '#E9896A',
            themeTertiary: '#d9a011',
            themeSecondary: '#deba2c',
            themeDarkAlt: '#d6b35a',
            themeDark: '#F0A500',
            themeDarker: '#dba102'
        }
    },
    {
        id: 'g',
        label: 'summer',
        palette: {
            themePrimary: '#f59251',
            themeLighterAlt: '#e6a86a',
            themeLighter: '#e3984d',
            themeLight: '#d19d69',
            themeTertiary: '#e39e59',
            themeSecondary: '#e38d54',
            themeDarkAlt: '#db7b3b',
            themeDark: '#d67b3e',
            themeDarker: '#db8851'
        }
    },
    {
        id: 'h',
        label: 'purple',
        palette: {
            themePrimary: '#4747d1',
            themeLighterAlt: '#4d4dbd',
            themeLighter: '#3333cc',
            themeLight: '#5c5cd6',
            themeTertiary: '#5c5ce0',
            themeSecondary: '#8585e0',
            themeDarkAlt: '#343499',
            themeDark: '#4444c2',
            themeDarker: '#6c6cdb'
        }
    },
    {
        id: 'i',
        label: 'porpora',
        palette: {
            themePrimary: '#e63061',
            themeLighterAlt: '#c92a55',
            themeLighter: '#bd3559',
            themeLight: '#bf506e',
            themeTertiary: '#db4670',
            themeSecondary: '#c23a5f',
            themeDarkAlt: '#a10b4e',
            themeDark: '#ad2147',
            themeDarker: '#9c3261'
        }
    },
        {
        id: 'l',
        label: 'choco',
        palette: {
            themePrimary: '#a12831',
            themeLighterAlt: '#ad6b53',
            themeLighter: '#a84434',
            themeLight: '#82543e',
            themeTertiary: '#8a2c35',
            themeSecondary: '#c22f33',
            themeDarkAlt: '#b3472d',
            themeDark: '#b05321',
            themeDarker: '#c25d44'
        }
    },
    {
        id: 'm',
        label: 'lavanda',
        palette: {
            themePrimary: '#E3B98C', 
            themeLighterAlt: '##ccab89',
            themeLighter: '#EFD7BD', 
            themeLight: '#EBCDAD',
            themeTertiary: '#EACDAE',
            themeSecondary: '#DEAF7D',
            themeDarkAlt: '#DAA56C', 
            themeDark: '#D69B5C',
            themeDarker: '#C57D30'
        }
    },
    {
        id: 'n',
        label: 'another-green',
        palette: {
            themePrimary: '#73A580',
            themeLighterAlt: '#C7EFCF',
            themeLighter: '#B2CAA4',
            themeLight: '#9DBD98',
            themeTertiary: '#568E65',
            themeSecondary: '#88B18C',
            themeDarkAlt: '#6D9F7A',
            themeDark: '#61926E', 
            themeDarker: '#548561'
        }
    }
];